export type PurchaseNotice = {
  name: string
  location: string
  timeAgo: string
}

export const purchaseNotices: PurchaseNotice[] = [
  { name: 'Michael', location: 'Florida', timeAgo: '5 minutes ago' },
  { name: 'Sophie', location: 'London', timeAgo: '11 minutes ago' },
  { name: 'Lucas', location: 'Berlin', timeAgo: '18 minutes ago' },
  { name: 'Emma', location: 'Austin, TX', timeAgo: '24 minutes ago' },
  { name: 'Mathieu', location: 'Paris', timeAgo: '32 minutes ago' },
  { name: 'Daniel', location: 'Chicago', timeAgo: '41 minutes ago' },
  { name: 'Isabel', location: 'Madrid', timeAgo: '47 minutes ago' },
  { name: 'Ryan', location: 'San Diego', timeAgo: '56 minutes ago' },
  { name: 'Nina', location: 'Amsterdam', timeAgo: '1 hour ago' },
  { name: 'Marco', location: 'Milan', timeAgo: '1 hour ago' },
  { name: 'Jessica', location: 'New York', timeAgo: '2 hours ago' },
  { name: 'Oliver', location: 'Dublin', timeAgo: '2 hours ago' },
]
